import React, { useContext, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import axios from 'axios'
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_orion";
import useHttp from "../../../hook/use-http";
import AppContext from "../../../store/AppContext";
import { isExpired, decodeToken } from "react-jwt";
import { useIdleTimer } from "react-idle-timer";
import "./Header_Orion.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from '../../../redux/userSlice';
import { FaRegListAlt } from 'react-icons/fa'
import { getAsset } from "../../assets/assetLoader";
import CustomTooltip from "../../Shared/CustomTooltip";

export default function Header_Orion() {
  let activeClassName = "nav-link active";
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let location = useLocation();
  let path_check = location.pathname;
  const lastSegment = path_check.split("/").pop();
  const [excelData, setexcelData] = useState([]);
  const [hasExcelAccess, setHasExcelAccess] = useState(false);
  const [hasselfserviceaccess, sethasselfserviceaccess] = useState(false);
  const [usernameTempHideShow, setUsernameTempHideShow] = useState(false)

  const navigate = useNavigate()
  const sessionToken = JSON.parse(sessionStorage.user)
  let myDecodedSessionToken = decodeToken(sessionToken.token)
  const webToken = sessionStorage?.user?.token

  const app_ctx = useContext(AppContext);
  const logout = () => {
    navigate('/')
    app_ctx.logout_user();
  };

  const get_token = () => {
    let token = ''
    if (
      sessionStorage.getItem('user') != '' &&
      sessionStorage.getItem('user') != null
    ) {
      token = JSON.parse(sessionStorage.user).token
    }
    return token
  }

  const redirectUser = async () => {
    let token = get_token()
    try {
      const response = await axios.post(
        API_URL_MAIN + 'auth/logout',
        {
          log: 'logout',
          ev_bus: myDecodedSessionToken?.ev_bus
        },
        {
          headers: {
            'x-auth-token': token,
            'Content-Type': 'application/json'
          }
        }
      )
      if (response?.status === 200 || response?.status === 201) {
        navigate('/')
      }
      // console.log('axios response: ', response)
    } catch (error) {
      // console.log('Error in axios: ', axios)
    }
  }

  const handleOnIdle = (event) => {
    app_ctx.logout_user();
  };
  useIdleTimer({ timeout: 300000, onIdle: handleOnIdle, debounce: 500 });
  const log_data = (data) => {
    setexcelData(data.data);
  };

  const [Departments, setDepartments] = useState([])
  const [UserCountTableData, setUserCountTableData] = useState([])
  const data_count = (data) => {
    setDepartments(['Engineering', 'Smart City', 'Quality', 'Customer Service', 'Total'])
    setUserCountTableData(data.data)
  }

  useEffect(() => {
    setexcelData(excelData);
    fetchData({ url: API_URL_MAIN + "auth/usage_logs_orion" }, log_data);
    fetchData({ url: API_URL_MAIN + "auth/all_users_count" }, data_count);

    const token = JSON.parse(sessionStorage.user);
    let myDecodedToken = decodeToken(token.token);
    let username = myDecodedToken.username;
    let access_type = myDecodedToken.access_type;
    var split_str = access_type ? access_type.split(",") : "";
    if (username === "sm925413.ttl" || username === "bipins.ttl" || username === "snehaj1.ttl" || username === "nv.ttl" || username === "sn927776.ttl") {
      setHasExcelAccess(true);
    }
    if (split_str.indexOf("6") !== -1) {
      sethasselfserviceaccess(true);
    }
    if (split_str.indexOf("9") !== -1) {
      setUsernameTempHideShow(true);
    }
  }, [hasExcelAccess, hasselfserviceaccess, usernameTempHideShow]);

  const excelFileName = "cesl user logs";
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, excelFileName + fileExtension);
  };

  const loggedInUser = useSelector(selectLoggedInUser);
  const selfserviceclick_bus = (e) => {
    e.preventDefault();
    fetchData({ url: API_URL_MAIN + "auth/logging", body: { page_name: "selfservice_orion", }, }, log_data);
    const API_URL = "https://cvtmls3.infoportal.tatamotors.com/login/loginFleetCESLEVApi?useremail=";
    const token = JSON.parse(sessionStorage.user);
    let myDecodedToken = decodeToken(token.token);
    const username = myDecodedToken.username;
    const table_name = myDecodedToken.table_name;
    const ev_bus = myDecodedToken.ev_bus;
    const hideShow = ev_bus.split("_");
    const loggedInType = hideShow[0];

    const url = API_URL + username + "@tatamotors.com&table_name=" + table_name + "&token=" + token + "&flag=Fleet&user=" + loggedInType;

    openInNewTab(url);
  };

  function openInNewTab(url) {
    var win = window.open(url, "");
    win.focus();
  }

  return (
    <>
      <nav className="navbar navbar-expand-md navbar-white bg-white shadow-sm">
        <div className="container-fluid">
          <NavLink to="/homepage" className="navbar-brand">
            <img src={getAsset("img_Bus/tml-logo.png")} style={{ height: 30 }} />
          </NavLink>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar" >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="navbar-collapse justify-content-center" id="mynavbar">
            <ul className="navbar-nav d-flex align-items-center">
              <li className="nav-item">
                <NavLink to="/homePage" className={({ isActive }) => isActive ? activeClassName : "nav-link"} style={{ display: "flex", alignItems: "center" }} >
                  <span className="material-symbols-outlined me-1 orion_nav_icon">home</span>
                  <span><b>Home</b></span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/vehicleinsights_orion" className={({ isActive }) => isActive ? activeClassName : "nav-link"} style={{ display: "flex", alignItems: "center" }} >
                  <span className="material-symbols-outlined me-1 orion_nav_icon"> insights </span>
                  <span> <b>Vehicle Insights</b> </span>
                </NavLink>
              </li>
              {hasselfserviceaccess &&
                <li className="nav-item" style={{ paddingLeft: "0.5rem", paddingRight: "0.5rem", cursor: "pointer" }} >
                  <a to="/vehicleinsights_orion" className={({ isActive }) => isActive ? activeClassName : "nav-link"} style={{ display: "flex", alignItems: "center", textDecoration: "none", }} href="#" onClick={selfserviceclick_bus} >
                    {/* {
                      hasselfserviceaccess && ( */}
                    <span className="material-symbols-outlined me-1 orion_nav_icon" style={{ color: "black" }}>person </span>
                    {/* )
                    } */}
                    {/* {
                      hasselfserviceaccess && ( */}
                    <span style={{ fontSize: "13px", color: "black" }}>
                      <b>Self Service</b>
                    </span>
                    {/* )
                    } */}
                  </a>
                </li>
              }

              {/* Back button for redirecting to vehicle selection page */}
              {/* <li
                className='nav-item'
                style={{
                  paddingLeft: '0.5rem',
                  paddingRight: '0.5rem',
                  cursor: 'pointer'
                }}
              >
                <a
                  className={({ isActive }) =>
                    isActive ? activeClassName : 'nav-link'
                  }
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    textDecoration: 'none',
                    gap: '5px'
                  }}
                  onClick={redirectUser}
                >
                  <FaRegListAlt style={{ color: 'black', fontSize: '13px' }} />
                  <span style={{ fontSize: '13px', color: 'black' }}>
                    <b>Project List</b>
                  </span>
                </a>
              </li> */}
            </ul>
          </div>

          <div style={{ float: 'right' }} className="cursor-pointer">
            <a
              className={({ isActive }) => (isActive ? activeClassName : 'nav-link')}
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                gap: '5px'
              }}
              onClick={redirectUser}
            >
              <CustomTooltip text="Back to vehicle list" placement="bottom">
                <FaRegListAlt style={{ color: '#83a4cf', fontSize: '16px' }} />
              </CustomTooltip>
              {/* <span style={{ fontSize: '13px', color: 'black' }}>
                <b>Project List 876543</b>
              </span> */}
            </a>
          </div>

          <form className="d-flex justify-content-end">
            <h2 className="Headfont" />
            <div className="col-2 justify-content-end d-flex">
              {
                (usernameTempHideShow && loggedInUser.flagForHideShow === "ERC") &&
                <div className="pt-2 pb-2">
                  <span className="material-icons hand_geture" data-tag="criticalFaultyCycle" data-bs-toggle="modal" data-bs-target="#model_users" style={{ color: "rgb(131, 164, 207)" }} >group</span>
                </div>
              }
              {
                lastSegment === "driveanalysis_orion" || lastSegment === "glossarypage_orion" ? (
                  <div className="pt-2 pb-2">
                    <span className="material-icons hand_geture" data-bs-toggle="dropdown" aria-expanded="false" data-bs-offset="10,5" style={{ color: "rgb(131, 164, 207)" }} >info</span>
                    <ul className="dropdown-menu">
                      <li>
                        <Link className="dropdown-item d-flex align-items-center" to="/dashboard_orion/glossarypage_orion" >
                          <span>Glossary Page</span>
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item d-flex align-items-center" to="/dashboard_orion/navigationguide_orion" >
                          <span>Navigation Guide</span>
                        </Link>
                      </li>
                      <li></li>
                    </ul>
                  </div>
                ) : (
                  <></>
                )
              }
              {
                lastSegment === "GlossaryPage_Fault_Bus" || lastSegment === "faultanalysis_bus" ? (
                  <div className="pt-2 pb-2">
                    <span className="material-icons hand_geture" data-bs-toggle="dropdown" aria-expanded="false" data-bs-offset="10,5" style={{ color: "rgb(131, 164, 207)" }} >info</span>
                    <ul className="dropdown-menu">
                      <li>
                        <Link className="dropdown-item d-flex align-items-center" to="/dashboard_orion/GlossaryPage_Fault_Bus" > <span>Glossary Page</span> </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item d-flex align-items-center" to="/dashboard_orion/navigationguide_fault_bus" ><span>Navigation Guide</span> </Link>
                      </li>
                      <li></li>
                    </ul>
                  </div>
                ) : (
                  <></>
                )
              }

              {
                lastSegment === "GlossaryPage_Charging_Orion" || lastSegment === "charginganalysis_orion" ? (
                  <div className="pt-2 pb-2">
                    <span className="material-icons hand_geture" data-bs-toggle="dropdown" aria-expanded="false" data-bs-offset="10,5" style={{ color: "rgb(131, 164, 207)" }} >info</span>
                    <ul className="dropdown-menu">
                      <li>
                        <Link className="dropdown-item d-flex align-items-center" to="/dashboard_orion/GlossaryPage_Charging_Orion" ><span>Glossary Page</span></Link>
                      </li>
                      <li>
                        <Link className="dropdown-item d-flex align-items-center" to="/dashboard_orion/navigationguide_Charging_Orion" > <span>Navigation Guide</span> </Link>
                      </li>
                      <li></li>
                    </ul>
                  </div>
                ) : (
                  <></>
                )
              }
              {
                lastSegment === "GlossaryPage_Trend_Bus" || lastSegment === "trendanalysis_bus" ? (
                  <div className="pt-2 pb-2">
                    <span className="material-icons hand_geture" data-bs-toggle="dropdown" aria-expanded="false" data-bs-offset="10,5" style={{ color: "rgb(131, 164, 207)" }} >info</span>
                    <ul className="dropdown-menu">
                      <li>
                        <Link className="dropdown-item d-flex align-items-center" to="/dashboard_orion/navigationguide_trend_bus" ><span>Navigation Guide</span> </Link>
                      </li>
                      <li></li>
                    </ul>
                  </div>
                ) : (
                  <></>
                )
              }
              {
                lastSegment === "GlossaryPage_Energy_Bus" || lastSegment === "energyanalysis_bus" ? (
                  <div className="pt-2 pb-2">
                    <span className="material-icons hand_geture" data-bs-toggle="dropdown" aria-expanded="false" data-bs-offset="10,5" style={{ color: "rgb(131, 164, 207)" }} >info</span>
                    <ul className="dropdown-menu">
                      <li>
                        <Link className="dropdown-item d-flex align-items-center" to="/dashboard_orion/GlossaryPage_Energy_Bus" ><span>Glossary Page</span></Link>
                      </li>
                      <li>
                        <Link className="dropdown-item d-flex align-items-center" to="/dashboard_orion/navigationguide_Energy_Bus" > <span>Navigation Guide</span> </Link>
                      </li>
                      <li></li>
                    </ul>
                  </div>
                ) : (
                  <></>
                )
              }
              <div className="ms-2">
                <img src="../../../assets/img_orion/sparqplug_logo_og.png" height={35} />
              </div>
              {
                hasExcelAccess && (
                  <div className="dropdown me-1 ms-2 mt-2">
                    <span className="material-icons dropdown-toggle colpurple" data-bs-toggle="dropdown" data-bs-offset="10,5" >
                      <svg className="mb-2" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                        <path fill="#83A4CF" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6m1.8 18H14l-2-3.4l-2 3.4H8.2l2.9-4.5L8.2 11H10l2 3.4l2-3.4h1.8l-2.9 4.5l2.9 4.5M13 9V3.5L18.5 9H13Z" />
                      </svg>
                    </span>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <span className="dropdown-item d-flex align-items-center" href="javascript:void(0);" onClick={exportToExcel} >
                          <span className="material-icons">info_outline</span>
                          <span className="ms-2">Usage Log</span>
                        </span>
                      </li>
                    </ul>
                  </div>
                )
              }
              <div className="dropdown me-1 ms-2 mt-2">
                <span className="material-icons dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-offset="10,5">logout</span>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <a className="dropdown-item d-flex align-items-center" href="javascript:void(0);" onClick={logout}>
                      <span className="material-icons">logout</span>
                      <span className="ms-2">Logout </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div >
      </nav >

      <div className="modal fade" id="model_users" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"><b>User Details</b></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <table className="table table-striped" style={{ width: "100%" }}>
                <thead className="popUpTable">
                  <tr>
                    <th scope="col">Department</th>
                    <th scope="col">CESL</th>
                    <th scope="col">ACE</th>
                    <th scope="col">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Departments.map((dept) => {
                      let tot = 0;
                      return (<tr key={dept}>
                        <td>{(dept === "Total") ? <b>{dept}</b> : dept}</td>
                        {
                          UserCountTableData.map((item) => {
                            tot = Number(tot) + Number(item[dept])
                            return (<td key={item[dept]}>{(dept === "Total") ? <b>{item[dept]}</b> : item[dept]}</td>)
                          })
                        }
                        <td>{(dept === "Total") ? <b>{tot}</b> : tot}</td>
                      </tr>)
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
